import { render, staticRenderFns } from "./ProductSuggestion.vue?vue&type=template&id=a33c878c&scoped=true"
import script from "./ProductSuggestion.vue?vue&type=script&lang=js"
export * from "./ProductSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33c878c",
  null
  
)

export default component.exports